module.exports = __webpack_public_path__ + "img/traffic-img.53f664cd.jpg";